import css from "../index.module.css";
import ReplayIcon from "@mui/icons-material/Replay";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { handleAvatar } from "../../../../utils/avatar.js";
import { deleteData, getDataById } from "../../../../utils/fetch";

const Table = ({students, setStudents, challenges, missions, classToChallenges, task, classId, studentToMission, studentToChallenge}) => {
  const [data, setData] = useState([]);

  const navigate = useNavigate();

    useEffect(() => {
      setData([]);
    if(task === "Challenges") {
      let tempStudent = [];
      let tempChallenges = [];
      students?.filter(f => f.class_id === classId).forEach(student => {
        tempChallenges = [];
        challenges?.filter(f => classToChallenges?.find(ff => ff.challenge_id === f.id)).forEach(challenge => {
          let tempChallenge = false
          let result = studentToChallenge?.find(f => (f.student_id === student.id || f.student2_id === student.id) && f.challenge_id === challenge.id);
          // eslint-disable-next-line
          if (result != null || result != undefined) {
            tempChallenge = true;
          }
          tempChallenges.push({id: challenge.id, type: "Challenge", completed: tempChallenge})
        })
        tempStudent.push({studentId: student.id, studentName: student.name, tasks: tempChallenges})       
      })
      setData(tempStudent);
      tempStudent = [];
    }

    if(task === "Missionen") {
      let tempStudent = [];
      let tempMissions = [];
      students?.filter(f => f.class_id === classId).forEach(student => {
        tempMissions = [];
        missions?.sort((a,b) => a.name - b.name).forEach(mission => {
          let tempMission = false;
          let result = studentToMission?.find(f => f.student_id === student.id && f.mission_id === mission.id);
          // eslint-disable-next-line
          if (result != null || result != undefined) {
            tempMission = true;
          }
          tempMissions.push({id: mission.id, type:"Mission", completed: tempMission})
        })
        tempStudent.push({studentId: student.id, studentName: student.name, tasks: tempMissions})       
      })
      setData(tempStudent);
      tempStudent = [];
    }
  }, [students, studentToChallenge, challenges, task, classToChallenges, missions, studentToMission, classId]);

    /**
   * Deletes the progress of a single student for a single challenge
   * @param {String} studentId 64 character uuid of given student
   * @param {String} challangeId 64 character uuid of given challenge
   */
  const handleDeleteProgress = (studentId, type, dataId) => {
    let apiString = "";
    if (type === "Challenge") {
      apiString = "/api/studentToChallenge/oneChallenge";
    } else {
      apiString = "/api/studentToMission/oneMission";
    }
    deleteData(apiString, {
      studentId: studentId,
      dataId: dataId,
    });
    navigate(0);
  };

  /**
   * Deletes the progress of a single student for all challenges after informing teacher of the risks of deletion
   * @param {String} studentId 64 character uuid of given student
   * @param {String} studentName Name of the student, to be put into the warning message
   */
  const handleDeleteStudentProgress = (studentId, studentName) => {
    if (window.confirm(
      "Sind Sie sich sicher, das Sie den gesamten Fortschritt für " + task + " von Schüler:in " +
        studentName +
        " löschen möchten? Die gespeicherten Zeiten sind nicht wiederherstellbar. Wenn Sie fortfahren möchten, klicken Sie auf OK."
    )) {
      if (task === "Missionen") {
        deleteData("/api/studentToMission/allMissions", {studentId: studentId});
      } else {
        deleteData("/api/studentToChallenge/allChallenges", { studentId: studentId });
      }
    }
    navigate(0);
  };

  /**
   * Deletes the progress of a whole class after informing teacher of the risks of deletion
   * @param {String} classId 64 character uuid of given class
   */
  const handleDeleteClassProgress = (classId) => {
    alert(
      "Sind Sie sich sicher, das Sie den gesamten Fortschritt der Klasse löschen möchten? Die gespeicherten Zeiten sind nicht wiederherstellbar. Wenn Sie fortfahren möchten, klicken Sie auf OK."
    );
    deleteData("/api/studentToMission/allClass", { classId: classId });
    deleteData("/api/studentToChallenge/allClass", { classId: classId }).then(() => {
      getDataById("/api/studentToChallenge/byId", { classId: classId }).then(
        (data) => {
          setStudents(data);
        }
      );
    });
  };

  /**
   * checks student name for given id
   * @param {String} studentId 64 character uuid of given student
   * @returns a student name or an remark that the given id has no name connected to it
   */
  const handleName = (studentId) => {
    if (students) {
      const student = students?.filter((e) => e.id === studentId);
      if (!student[0]) {
        return "kein name gefunden";
      }
      if (student[0].use_nickname) {
        return student[0].nickname;
      }
      return student[0].name;
    }
  };

  return (
        <div className={css.tableContainer}>
          <div className={css.progress}>
            <table>
              <thead>
                <tr>
                  <td>{task}</td>
                </tr>
              </thead>
              <tbody>
                {students?.filter(f => f.class_id === classId).map((student) => {
                    return (
                      <tr key={"row" + student.id}>
                        <td className={css.studentcell}>
                          {handleAvatar(student.use_avatar, student.avatar, student.name)}
                          <span>{handleName(student.id)}</span>
                        </td>
                      </tr>
                    );
                  })
                }
              </tbody>
            </table>
            <table>
              <thead>
                <tr>
                  {task === "Missionen" ? 
                    (missions?.map(e => {
                      return <td key={"tableDataMission_" + e.name}>{e.name}</td>
                    })) : 
                    (challenges?.filter(f => classToChallenges?.find(ff => ff.challenge_id === f.id)).map((e) => {
                      return <td key={"tableDataChallenge_" + e.name}>{e.name}</td>;
                    }))
                  }
                </tr>
              </thead>
              <tbody>
                {data?.map(student => {
                  return(
                    <tr key={"tableDataRow_" + student.studentId}>
                      {student?.tasks?.map(task => {
                        return <td key={"tableData_" + student.studentId + "_" + task.type + "_" + task.id}>{task.completed ? <CheckBoxIcon onClick={() => handleDeleteProgress(student.studentId, task.type, task.id)}/> : <CheckBoxOutlineBlankIcon />}</td>
                      })}
                    </tr>
                  )
                })}
              </tbody>
            </table>
            <table>
              <thead>
                <tr>
                  <td>
                    <SettingsBackupRestoreIcon
                      onClick={() => handleDeleteClassProgress(classId)}
                    />
                  </td>
                </tr>
              </thead>
              <tbody>
                {students?.filter(f => f.class_id === classId).map((student) => {
                    return (
                      <tr key={"row" + student.id}>
                        <td>
                          <ReplayIcon
                            onClick={() =>
                              handleDeleteStudentProgress(
                                student.id,
                                handleName(student.id)
                              )
                            }
                          />
                        </td>
                      </tr>
                    );
                  })
                }
              </tbody>
            </table>
          </div>
        </div>
  )
}

export default Table;